import React from "react";
import { CardContent, Typography, Box, Grid } from "@mui/material";
import { StyledCard } from "../../assets/styled-components/StyledCard";
import { useNavigate } from "react-router-dom";
import { useAccess } from "../../AccessContext";
import utilities from "../../utility/utilities";

function ContractAndLicense({ response, responseFem }) {

  const navigate = useNavigate();
  const accessData = useAccess();

  console.log("accessData", accessData.screenAccess);


  return (
    <StyledCard variant="outlined">
      <CardContent>
        <Typography
          mb={1.5}
          variant="h5"
          fontWeight={700}
          color={"text.primary"}
        >
          Contract & License Details
        </Typography>

        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            sm={4}
            sx={{ cursor: "pointer" }}
            onClick={() => {
              if (accessData.screenAccess["ENGT005"]) {
                navigate("/contractmanagement", { state: { tab: 1 } });
              }
            }}
          >
            <StyledCard variant="outlined">
              <CardContent>
                <Typography mb={1} color={"text.primary"}>
                  Active Contract
                </Typography>
                <Typography variant="h1" color={"text.secondary"}>
                  {response?.totalContractsActiveCount}
                </Typography>
              </CardContent>
            </StyledCard>
          </Grid>

          <Grid item xs={12} sm={4} sx={{ cursor: "pointer" }}  onClick={() => {
              if (accessData.screenAccess["ENGT005"]) {
                navigate("/contractmanagement", { state: { tab: 2 } });
              }
            }}
          >
            <StyledCard variant="outlined">
              <CardContent>
                <Typography mb={1} color={"text.primary"}>
                  Expiring within  6 months
                </Typography>
                <Typography variant="h1" color={"error.dashboard"}>
                  {response?.totalContractsexpirein180daysCount}
                </Typography>
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item xs={12} sm={4} sx={{ cursor: "pointer" }}  onClick={() => {
              if (accessData.screenAccess["ENGT005"]) {
                navigate("/contractmanagement", { state: { tab: 3 } });
              }
            }}
          >
            <StyledCard variant="outlined">
              <CardContent>
                <Typography mb={1} color={"text.primary"}>
                  Expiring within  3 months
                </Typography>
                <Typography variant="h1" color={"error.dashboard"}>
                  {response?.totalContractsexpirein90daysCount}
                </Typography>
              </CardContent>
            </StyledCard>
          </Grid>
        </Grid>

        <Grid container spacing={2} mt={2}>
          <Grid item xs={12} sm={4} sx={{ cursor: "pointer" }}  onClick={() => {
              if (accessData.screenAccess["ENGT005"]) {
                navigate("/contractmanagement", { state: { tab: 4 } });
              }
            }}
          >
            <StyledCard variant="outlined">
              <CardContent>
                <Typography mb={1} color={"text.primary"}>
                  Expiring within  1 month
                </Typography>
                <Typography variant="h1" color={"error.dashboard"}>
                  {response?.totalContractsexpirein30daysCount}
                </Typography>
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item xs={12} sm={4} sx={{ cursor: "pointer" }} onClick={() => {
              if (accessData.screenAccess["ENGT005"]) {
                navigate("/contractmanagement", { state: { tab: 5 } });
              }
            }}
          >
            <StyledCard variant="outlined">
              <CardContent>
                <Typography mb={1} color={"text.primary"}>
                  Expiring within  1 week
                </Typography>
                <Typography variant="h1" color={"error.dashboard"}>
                  {response?.totalContractsexpirein7daysCount}
                </Typography>
              </CardContent>
            </StyledCard>
          </Grid>

          <Grid item xs={12} sm={4} sx={{ cursor: "pointer" }}  onClick={() => {
              if (accessData.screenAccess["ENGT005"]) {
                navigate("/contractmanagement", { state: { tab: 6 } });
              }
            }}
          >
            <StyledCard variant="outlined">
              <CardContent>
                <Typography mb={1} color={"text.primary"}>
                  Expired
                </Typography>
                <Typography variant="h1" color={"error.dashboard"}>
                  {response?.totalContractexpireCount}
                </Typography>
              </CardContent>
            </StyledCard>
          </Grid>

          <Grid item xs={6} sm={12} style={{ display: 'flex', justifyContent: 'left' }}>
            <Typography mb={0.5} color={"text.primary"}>
              <hr style={{ width: 300 }} />
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography mb={1} color={"text.primary"}>
              Licenses in Active
            </Typography>
            <Typography variant="h1" color={"text.secondary"}>
              {responseFem?.totalLicenseActiveCount}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography mb={1} color={"text.primary"}>
              Expiring within  90 days
            </Typography>
            <Typography variant="h1" color={"error.dashboard"}>
              {responseFem?.totalLicenseexpirein90daysCount}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </StyledCard>
  );
}

export default ContractAndLicense;
